/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AbstractSchemaBean } from './AbstractSchemaBean';
import {
    AbstractSchemaBeanFromJSON,
    AbstractSchemaBeanFromJSONTyped,
    AbstractSchemaBeanToJSON,
} from './AbstractSchemaBean';
import type { ProductAttribute } from './ProductAttribute';
import {
    ProductAttributeFromJSON,
    ProductAttributeFromJSONTyped,
    ProductAttributeToJSON,
} from './ProductAttribute';

/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    iuName?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    iuVersion?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    hidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    marktgFeature?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    critical?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    iceAttributes?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    updateSiteId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Product
     */
    langsCollection?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    updatesiteVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    authorId?: number;
    /**
     * 
     * @type {Array<ProductAttribute>}
     * @memberof Product
     */
    productAttributes?: Array<ProductAttribute>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    notes?: string;
}

/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductFromJSON(json: any): Product {
    return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): Product {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iuName': !exists(json, 'iuName') ? undefined : json['iuName'],
        'iuVersion': !exists(json, 'iuVersion') ? undefined : json['iuVersion'],
        'hidden': !exists(json, 'hidden') ? undefined : json['hidden'],
        'marktgFeature': !exists(json, 'marktgFeature') ? undefined : json['marktgFeature'],
        'critical': !exists(json, 'critical') ? undefined : json['critical'],
        'iceAttributes': !exists(json, 'iceAttributes') ? undefined : json['iceAttributes'],
        'updateSiteId': !exists(json, 'updateSiteId') ? undefined : json['updateSiteId'],
        'langsCollection': !exists(json, 'langsCollection') ? undefined : json['langsCollection'],
        'updatesiteVersion': !exists(json, 'updatesiteVersion') ? undefined : json['updatesiteVersion'],
        'authorId': !exists(json, 'authorId') ? undefined : json['authorId'],
        'productAttributes': !exists(json, 'productAttributes') ? undefined : ((json['productAttributes'] as Array<any>).map(ProductAttributeFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function ProductToJSON(value?: Product | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iuName': value.iuName,
        'iuVersion': value.iuVersion,
        'hidden': value.hidden,
        'marktgFeature': value.marktgFeature,
        'critical': value.critical,
        'iceAttributes': value.iceAttributes,
        'updateSiteId': value.updateSiteId,
        'langsCollection': value.langsCollection,
        'updatesiteVersion': value.updatesiteVersion,
        'authorId': value.authorId,
        'productAttributes': value.productAttributes === undefined ? undefined : ((value.productAttributes as Array<any>).map(ProductAttributeToJSON)),
        'id': value.id,
        'name': value.name,
        'notes': value.notes,
    };
}

